import { Company, Pagination, User, UserProcess } from '@interfaces';

export const employeesProcessesDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'updatedAt',
  orderDir: 'desc',
  count: 0,
};

export const managersDefaultPagination = {
  all: 0,
  limit: 25,
  offset: 0,
  orderBy: 'name',
  orderDir: 'desc',
  count: 0,
};

export type CompanyState = Readonly<{
  loading: boolean;
  companies: Partial<Company>[];
  loadedCompanyDetails: Company | null;
  errorMessage: any;
  employeesProcesses: Partial<UserProcess>[];
  employeesProcessesPagination: Pagination;

  loadingManagersList: boolean;
  managers: Partial<User>[];
  managersPagination: Pagination;
  managersErrorMessage: string | null;
  loadedManagerDetails: Partial<User>;
  loadingManagerDetails: boolean;

  loadingCompanyOfSelfRegistered: boolean;
  companyOfSelfRegistered: Partial<Company> | null;

  allActiveCompanies: Partial<Company>[] | null;
  allInactiveCompanies: Partial<Company>[] | null;
}>;

export const initialState: CompanyState = {
  loading: false,
  companies: [],
  loadedCompanyDetails: null,
  errorMessage: null,

  employeesProcesses: null,
  employeesProcessesPagination: { ...(employeesProcessesDefaultPagination as Pagination) },

  loadingManagersList: false,
  managers: [],
  managersPagination: { ...(managersDefaultPagination as Pagination) },
  managersErrorMessage: null,
  loadedManagerDetails: null,
  loadingManagerDetails: false,

  loadingCompanyOfSelfRegistered: false,
  companyOfSelfRegistered: null,
  allActiveCompanies: null,
  allInactiveCompanies: null,
};
